import { render, staticRenderFns } from "./SyllabusTableCheckbox.vue?vue&type=template&id=19819c00&"
import script from "./SyllabusTableCheckbox.vue?vue&type=script&lang=js&"
export * from "./SyllabusTableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports